// Configuration for enabling/disabling sections
// 1 = enabled, 0 = disabled
export const sectionConfig = {
  featuredVideos: 0,
  testimonials: 1,
  newsletter: 0,
} as const;

// Type for the section config
export type SectionConfig = typeof sectionConfig;